import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { string } from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router';

import { neutral, yellow } from '../../../../styles/mui/colors';
import Link from '../../../Links/Link/Link';
import { withBaseComponent } from '../../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.blok
 * @param {string | null} props.category
 * @param {string} [props.currentCategory]
 */

const StoryblokArchiveBlogCategory = ({ blok, category, currentCategory = undefined }) => {
  const { label = '' } = blok;

  const location = useLocation();
  const isActive = currentCategory === category;
  const searchParams = !!category && new URLSearchParams({ category: category }).toString();

  return (
    <Link
      to={{
        pathname: location.pathname,
        ...(searchParams ? { search: searchParams } : {}),
      }}
    >
      <Chip
        label={<Typography variant="body2">{label}</Typography>}
        sx={{
          backgroundColor: isActive ? yellow.main : 'white',
          border: `1px solid ${neutral[200]}`,
          boxShadow: 0,
          px: 1,
          py: 2,
          '&:hover': {
            cursor: 'pointer',
            boxShadow: '0px 0 24px rgba(0,0,0,0.08)',
          },
        }}
      />
    </Link>
  );
};

export default withBaseComponent(StoryblokArchiveBlogCategory);
